export type Section =
  | "clinicalTrials"
  | "clinicalTrialStatus"
  | "Deals"
  | "Regulatory"
  | "expeditedProgram"
  | "ventureCapital"
  | "publication"
  | "publicationJournal"
  | "conferenceSchedule"
  | "companyWebsiteVariousPages"
  | "dealFiling"
  | "fundingFiling"
  | "ctg"
  | "regulatoryLabel"
  | "patent";

export type SectionCode =
  | "TY001"
  | "TY002"
  | "TY003"
  | "TY004"
  | "TY005"
  | "TY006"
  | "TY007"
  | "TY008"
  | "TY010"
  | "TY011"
  | "TY801"
  | "TY802"
  | "TY018"
  | "TY101"
  | "TY201";

const BASE_SECTION_ACCORDING_TO_CLASSIFICATION: Record<string, Section> = {
  C000: "clinicalTrials",
  C001: "clinicalTrialStatus",
  C003: "clinicalTrials",
  C004: "conferenceSchedule",
  C005: "clinicalTrials",
  C006: "Deals",
  C007: "clinicalTrials",
  C008: "publicationJournal",
  C009: "clinicalTrials",
  C010: "clinicalTrials",
  C011: "clinicalTrials",
  C012: "clinicalTrials",
  C013: "Regulatory",
  C201: "regulatoryLabel",
  C202: "regulatoryLabel",
  C014: "clinicalTrials",
  C015: "clinicalTrials",
  C016: "expeditedProgram",
  C017: "clinicalTrials",
  C018: "clinicalTrials",
  C019: "clinicalTrials",
  C020: "clinicalTrials",
  C021: "ventureCapital",
  C022: "clinicalTrials",
  C023: "clinicalTrials",
  C024: "clinicalTrials",
  C025: "clinicalTrials",
  C101: "companyWebsiteVariousPages",
  P001: "publication",
  P002: "publication",
  P004: "publication",
  P005: "publication",
  P006: "publication",
  P007: "publication",
  P008: "publication",
  P009: "publication",
  P010: "publication",
  P011: "publication",
  P012: "publication",
  P013: "publication",
  P014: "publication",
  P999: "publication",
  C801: "dealFiling",
  C802: "fundingFiling",
  ctg: "ctg",
  regulatoryLabel: "regulatoryLabel",
};

export const SECTION_ACCORDING_TO_CLASSIFICATION: Record<string, Section> =
  new Proxy(BASE_SECTION_ACCORDING_TO_CLASSIFICATION, {
    get: (target, prop: string) =>
      prop.startsWith("DERA") ? "ctg" : Reflect.get(target, prop),
  });

export const SECTION_CODE: Record<Section, SectionCode> = {
  clinicalTrials: "TY001",
  clinicalTrialStatus: "TY005",
  Deals: "TY002",
  Regulatory: "TY003",
  expeditedProgram: "TY004",
  ventureCapital: "TY006",
  publication: "TY008",
  publicationJournal: "TY010",
  conferenceSchedule: "TY011",
  dealFiling: "TY801",
  fundingFiling: "TY802",
  ctg: "TY007",
  regulatoryLabel: "TY101",
  companyWebsiteVariousPages: "TY018",
  patent: "TY201",
};
